module.exports = __webpack_public_path__ + "img/ad_credit_card.09ee1dff.jpg";